import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContenedoresService } from './../../../../../../../../services/API/contenedores/contenedores.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { NotificationServiceService } from './../../../../../../../../services/notification-service/notification-service.service';
import { EditMovimientoComponent } from './../edit-movimiento/edit-movimiento.component'; 

@Component({
    selector: 'app-new-movimiento',
    templateUrl: './new-movimiento.component.html',
    styleUrls: ['./new-movimiento.component.css'],
    standalone: false
})
export class NewMovimientoComponent implements OnInit {

  showProgressBar: boolean = true;
  contenedores: any = [];
  contenedoresEntrega: any = [];
  contenedoresRetirada: any = [];
  form: UntypedFormGroup;
  tipo: string = 'entrega';
  contenedorEntrega: any = -1;
  contenedorRetirada: any = -1;
  fecha: any = "";
  fechaFinal: any = "";
  albaran: string;
  observaciones: string = '';
  cliente: string = '';
  latitud: string = '';
  longitud: string = '';

  constructor(private fb: UntypedFormBuilder, private contenedoresService: ContenedoresService, private notificationService: NotificationServiceService, 
              @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog, private dialogRef: MatDialogRef<NewMovimientoComponent>) { }

  ngOnInit(): void {
    if(this.data['contenedor'] === 'all'){
      this.contenedorEntrega = -1;
      this.contenedorRetirada = -1;
    }else{
      this.contenedorEntrega = this.data['contenedor'];
      this.contenedorRetirada = this.data['contenedor'];
    }
    this.fecha = new Date();
    this.fechaFinal = this.fecha.getDate()+"-"+(this.fecha.getMonth()+1)+"-"+this.fecha.getFullYear();
    this.getContenedores();
    this.form = this.fb.group({
      tipo: [this.tipo, [Validators.required, Validators.minLength(1)]],
      contenedorEntrega: [this.contenedorEntrega, []],
      contenedorRetirada: [this.contenedorRetirada, []],
      fecha: [this.fecha, [Validators.maxLength(128)]],
      albaran: [this.albaran, [Validators.required, Validators.minLength(1), Validators.maxLength(256), Validators.pattern("^[0-9]*$")]],
      observaciones: [this.observaciones, [Validators.maxLength(128)]],
      cliente: [this.cliente, [Validators.required, Validators.minLength(1), Validators.maxLength(128)]],
    });
  }

  getContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getContenedores('all').subscribe(result => {
      this.showProgressBar = false;
      this.contenedores = result;
      this.contenedoresEntrega = this.contenedores;
      this.contenedoresRetirada = this.contenedores;
    });
  }

  filterSelect_ContenedoresEntrega(value: string) { 
    this.contenedoresEntrega = this.contenedores.filter(option => option['matricula'].toLowerCase().includes(value.toLowerCase()));
  }

  filterSelect_ContenedoresRetirada(value: string) { 
    this.contenedoresRetirada = this.contenedores.filter(option => option['matricula'].toLowerCase().includes(value.toLowerCase()));
  }

  save(saveAndEdit: boolean = false) {
    const {value, valid} = this.form;
    if(valid){
      if(value.tipo === 'entrega' && value.contenedorEntrega.length === 0){
        this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
        return;
      }
      if(value.tipo === 'retirada' && value.contenedorRetirada.length === 0){
        this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
        return;
      }
      if(value.tipo === 'cambio' && (value.contenedorEntrega.length === 0 || value.contenedorRetirada.length === 0)){
        this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
        return;
      }
      this.showProgressBar = true;
      this.contenedoresService.newMovimiento(value.tipo, value.contenedorEntrega.toString(), value.contenedorRetirada.toString(), this.fechaFinal, value.albaran, value.observaciones, value.cliente, this.latitud, this.longitud).subscribe( result => {
        this.notificationService.openSnackBar("Movimiento registrado correctamente!");
        this.showProgressBar = false;
        if(saveAndEdit === true){
          this.editMovimiento(parseInt(result['id']), value.tipo, value.contenedorEntrega, value.contenedorRetirada, this.fechaFinal, value.albaran, value.observaciones, value.cliente, this.latitud, this.longitud);
        }
        this.close('save');
      }); 
    }else{
      this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
    }
  }

  editMovimiento(id: number, tipo: string, contenedorEntrega: number, contenedorRetirada: number, fechaFinal: string, albaran: string, observaciones: string, cliente: string, latitud: string, longitud: string){
    const modifDialog = this.dialog.open(EditMovimientoComponent, {
      data: {'movimiento': id, 'tipo' : tipo, 'contenedorEntrega' : contenedorEntrega, 'contenedorRetirada' : contenedorRetirada, 'fecha' : fechaFinal, 'albaran' : albaran, 'observaciones' : observaciones, 'cliente' : cliente, 'latitud' : latitud, 'longitud' : longitud},
      width: '90%',
      maxWidth: '500px'
    });
    modifDialog.afterClosed().subscribe(result => {
      if(result === 'save'){
        this.notificationService.openSnackBar("Movimiento actualizado correctamente!");
      }
    });
  }

  close(data: string = '') {
    this.dialogRef.close(data);
  }

  dateChange(event: any){
    let fecha: any = new Date(event.target.value);
    fecha = fecha.getDate()+"-"+(fecha.getMonth()+1)+"-"+fecha.getFullYear();
    this.fechaFinal = fecha;
  }

  newLatitudEvent(latitud: any) {
    this.latitud = latitud;
  }

  newLongitudEvent(longitud: any) {
    this.longitud = longitud;
  }

}
